import axiosConfig from '../modules/axiosConfig'
import utils from '../modules/utils'
import router from '../../router'

const HTTP = axiosConfig.HTTP

// state
const state = {
  code: '',
  loading: false,
  error: '',
  errorDescription: '',
  maxInactiveTime: 0,
  isPasswordText: false,
  mqPhone: window.matchMedia('(max-width: 767px)')
}

// getters
const getters = {
}

// actions
const actions = {
  async logout ({ commit, rootState }, data) {
    const config = rootState.appConfig.configFile

    try {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const storageAppToken = sessionStorage.getItem('token')
      const hashToken = utils.SHA256(storageAppData.entidad + storageAppToken + storageAppData.canal)
      let body = {}
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: false,
            businesstimeout: '',
            canal: storageAppData.canal,
            claveFin: '',
            claveInicio: '',
            entidad: storageAppData.entidad,
            idioma: 'ES',
            indMasDatos: '',
            oficina: '',
            pantPagina: 0,
            retroceder: false,
            mainUser: storageAppData.mainUser,
            securityToken: hashToken
          }
        }
      })
      commit('LOGOUT_REQUEST_STARTED', true)
      const response = await HTTP.post(config.endpoints.logout, body)
      if (response.status === 200) {
        switch (response.data.runServiceResponse.return.retorno) {
          case '000':
            commit('LOGOUT_REQUEST_SUCCEED', response.data.runServiceResponse.return)
            break
          case 200:
            commit('LOGOUT_REQUEST_FAILED', response.data.runServiceResponse.return)
            break
          case 220:
            commit('LOGOUT_REQUEST_FAILED', response.data.runServiceResponse.return)
            break
          default:
            commit('LOGOUT_REQUEST_FAILED', response.data.runServiceResponse.return)
            break
        }
      }
      commit('RESET_STATE')
      commit('LOGOUT_REQUEST_FINISHED', false)
      return response
    } catch (error) {
      return error
    }
  },
  loader ({ commit }, actions) {
    commit('SET_LOADER', actions)
  }
}

// mutations
const mutations = {
  'SET_LOADER' (state, actions) {
    state.loading = actions.loader === true
    state.isPasswordText = actions.password === true
  },
  'LOGOUT_REQUEST_STARTED' (state, payload) {
    state.loading = payload
  },
  'LOGOUT_REQUEST_FINISHED' (state, payload) {
    state.loading = payload
  },
  'LOGOUT_REQUEST_SUCCEED' (state, payload) {
    state.code = payload
    state.error = false
    state.errorDescription = ''
    sessionStorage.clear()
    router.push({ name: 'Login' })
  },
  'LOGOUT_REQUEST_FAILED' (state, payload) {
    if (payload.retorno === 200) {
      state.errorDescription = 'Error ejecución de servicio'
    } else if (payload.retorno === 220) {
      state.errorDescription = 'Error técnico'
    }
    state.error = true
    state.code = ''

    // prueba al saltar error del token porque no cierra sesion
    sessionStorage.clear()
    router.push({ name: 'Login' })
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}
